// removed by extract-text-webpack-plugin
module.exports = {"input":"index__input___1zC09","display":"index__display___1Kgfx","select":"index__select___3CYNP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/AdditionSelector/index.less
// module id = 856
// module chunks = 3